module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-calendar"
  }, [_c('calendar-header', {
    attrs: {
      "locale": _vm.locale,
      "disabled": _vm.disabledDays,
      "full-month-names": _vm.fullMonthNames,
      "first-day-of-month": _vm.currentMonthStart
    },
    on: {
      "changeMonth": _vm.changeMonth
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "calendar-body"
  }, [_c('div', {
    staticClass: "days-header"
  }, _vm._l((7), function(dayNumber) {
    return _c('strong', {
      staticClass: "day-label"
    }, [_vm._v(_vm._s(_vm._f("dayToString")((dayNumber - 1), _vm.locale, _vm.firstDay, _vm.fullDayNames)))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "days-container"
  }, _vm._l((_vm.calendar), function(week) {
    return _c('div', {
      staticClass: "week-row"
    }, _vm._l((week), function(day) {
      return _c('div', {
        staticClass: "week-day-cell",
        class: {
          today: day.isToday,
          weekend: day.isWeekend,
          saturday: day.isSaturday,
          sunday: day.isSunday,
          disabled: _vm.isDayDisabled(day),
          highlighted: _vm.isDayHighlighted(day),
          'not-current-month': !day.isCurrentMonth,
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.dayClick(day)
          }
        }
      }, [_c('div', {
        staticClass: "day-number"
      }, [_vm._v("\n                        " + _vm._s(day.monthDay) + "\n                    ")]), _vm._v(" "), _c('events-box', {
        attrs: {
          "events": day.events,
          "day": day,
          "show-limit": _vm.showLimit
        },
        on: {
          "eventClicked": _vm.eventClicked,
          "showMore": _vm.showEventsModal
        }
      })], 1)
    }), 0)
  }), 0)]), _vm._v(" "), (_vm.showModal) ? _c('events-modal', {
    attrs: {
      "events": _vm.currentEventsList
    },
    on: {
      "hideModal": _vm.hideEventsModal
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-021bccc4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/vue-calendar/calendar.vue
// module id = 1154
// module chunks = 0